import { alpha, Grid2, IconButton, styled, Typography } from '@mui/material';

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  height: '100vh',
  '@media(max-width: 750px)': {
    display: 'none',
  },
}));

export const TitleContainerStyled = styled(Grid2)(({ theme }) => ({
  color: theme.palette.global.gray,
  padding: '40px 0 40px 80px',
}));

export const PageTitleStyled = styled(Typography)({
  margin: '12px 16px',
});

export const BoxStyled = styled(Grid2)({
  backgroundColor: '#FFFFFF',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
  marginRight: '20px',
  marginLeft: '20px',
  marginBottom: '68px',
  padding: '40px',
});

export const PayableInfoStyled = styled(Typography)({
  margin: '20px 0',
  fontWeight: 500,
});

export const ItemsTitleStyled = styled(Grid2)({
  width: '100%',
  height: 48,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#f2f2f2cc',
  paddingLeft: 32,
  borderRadius: 4,
  marginTop: 32,
  marginBottom: '1em',
  boxShadow: '2px 2px 2px #ccc',
});

export const LinksAndTotalStyled = styled(Grid2)({
  display: 'flex',
  justifyContent: 'space-between',
  paddingRight: 5,
  marginTop: 32,
});

export const AttachmentsListStyled = styled('div')({
  padding: '12px',
  backgroundColor: '#f2f2f2',
  margin: '24px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 48,
});

export const FileNameStyled = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const MobileDivStyled = styled('div')({
  margin: 0,
  '@media(min-width: 751px)': {
    display: 'none',
  },
});

export const HeadersLinkStyled = styled('div')(({ theme }) => ({
  '@media(min-width: 751px)': {
    display: 'none',
  },
  padding: '16px 28px 28px 24px',
  color: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  '& a': {
    textDecoration: 'underline',
    color: theme.palette.secondary.main,
    fontFamily: 'montserrat',
    fontSize: 13,
  },
}));

export const CardTitleStyled = styled('div')(({ theme }) => ({
  margin: '24px 16px',
  borderRadius: 8,
  height: '5rem',
  backgroundColor: alpha(theme.palette.secondary.main, 0.2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  padding: 4,
  '& p': {
    color: '#FF4A56',
  },
  '& h3': {
    color: '#00285A',
  },
}));

export const ButtonCopyStyled = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.global.white,
  marginLeft: '45%',
}));

export const DetailedPayableStyled = styled('div')({
  padding: 16,
  '& div': {
    borderTop: '1px solid #ccc',
    padding: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4,
    '&:last-child': {
      borderBottom: '1px solid #ccc',
    },
  },
  '& .items': {
    '& + p': {
      color: ({ theme }) => theme.palette.primary.main,
    },
  },
});

export const AttachmentsStyled = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.secondary.main}`,
  maxHeight: 48,
  margin: 16,
  padding: 16,
  borderRadius: 22,
  color: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  '& svg': {
    fontSize: 20,
  },
  '& p': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
